import { ReactComponent as Icon } from "../files/cancel-filled-icon.svg";

import ISVGIconProps from "../ISVGIconProps";

const FilledCrossIcon = ({ fill, style = {}, title }: ISVGIconProps) => {
    return <Icon style={style} fill={fill} title={title}/>;
};

export default FilledCrossIcon;
